import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'cd-eft/components/common/Alert/Alert';
import { SurveyListDataGrid } from 'cd-eft/components/SurveyEngineering/SurveyListDataGrid/SurveyListDataGrid';
import { SurfaceDesignerVm } from './SurfaceDesignerVm';
import './SurfaceDesigner.scss';

// Design
import { ToolSlot } from '../BreaklineTools/framework/Tool';
import stores from 'cd-eft/models/Stores';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import MapLegend from '../MapLegend/MapLegend';

const setStore = stores.AppStore.surveyEngineeringStore;

interface ISurfaceDesignerComponentProps {
  vm: SurfaceDesignerVm;
  // surfaceDef?: SurfaceDef;
  toolSlot: ToolSlot;
  designREF: any;
  updateSnapIcon: any;
  toggleSnapping: any;
}
function SurfaceDesignerComponent(props: ISurfaceDesignerComponentProps) {
  const vm = props.vm;

  useEffect(() => {
    vm.getErrors();
    vm.onMount();

    const cleanup = () => {
      MessageCenter.clearMessages();
      vm.onUnmount();
    };
    return cleanup;
  }, []);

  useEffect(() => {
    vm.setUncommittedEdits();
    if (vm.surfaceDef && (vm.surfaceDef?.countPointsModified > 0 || vm.surfaceDef?.contourIntervalModified)) {
      vm.openToolBar()
    }
    if (vm.surfaceDef && vm.surfaceDef?.breaklinesPendingEditCount >= 0) {
      vm.addBreaklineEdits();
    }
  }, [
    vm.surfaceDef?.isBorderModified,
    vm.surfaceDef?.breaklinesPendingEditCount,
    vm.drawings.pendingEditCount,
    vm.surfaceDef?.countPointsModified,
    vm.surfaceDef?.contourIntervalModified
  ]);

  useEffect(() => {
    vm.surveyDesignForceOpen = false;
    setStore.triggerSurfaceDesignerVm = vm;
  }, [vm.surveyDesignForceOpen]);

  useEffect(() => {
    if (setStore.pointsOnMap) {
      vm.setGroundPointsVisibility(false);
    } else {
      vm.setGroundPointsVisibility(true);
    }
  }, [setStore.pointsOnMap]);

  return (
    <>
      <SurveyListDataGrid surveyDesignForceOpen={true} designREF={props.designREF} startWatchHandler={vm.startViewPointerMoveHandler} stopWatchHandler={vm.removeViewPointerMoveHandler} updateSnapIcon={props.updateSnapIcon} toggleSnapping={props.toggleSnapping} />

      <MapLegend />

      {/* popups */}
      {vm.error && <Alert show={vm.error} type="error" msg={vm.errorMsg} />}

      {(setStore.currentSurvey.surveyName || vm.uncommittedEdits > 0) && (stores.AppStore.designStore.hasProject()) && (
        <UserLeavingWarning
          when={Boolean(setStore.currentSurvey.surveyName) || vm.uncommittedEdits > 0}
          section="Survey Design"
          onOK={vm.userLeavingWarningOnOk}
          text={
            setStore.currentSurvey.surveyName
              ? vm.notification.openSurvey
              : vm.uncommittedEdits > 0
                ? vm.notification.uncommittedEdits
                : ''
          }
        />
      )}
    </>
  );
}

export const SurfaceDesigner = observer(SurfaceDesignerComponent);
